import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import styles from './Modal.module.scss';

type ModalContentProps = Omit<ComponentPropsWithoutRef<'div'>, 'slot'>;

const ModalContent: React.FC<ModalContentProps> = ({ children, className, ...props }) => {
  return (
    <div slot="content" className={clsx(styles.content, className)} {...props}>
      {children}
    </div>
  );
};

export default ModalContent;
